<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// Zoo Snoods newsletter popup (Shopify Forms app) customization:
// 1. Recolors only the collapsed teaser tab (not the form or success screen).
// 2. Adds a "No thanks" link under the Join Now button that closes the popup.
(function () {
  var TEASER_BG = '#E95144';
  var TEASER_FG = '#FFFFFF';

  function styleTeaser(shadowRoot) {
    var teaser = shadowRoot.querySelector('[data-testid="form-teaser"]');
    if (!teaser) return;
    teaser.style.setProperty('background-color', TEASER_BG, 'important');
    var heading = teaser.querySelector('h3');
    if (heading) heading.style.setProperty('color', TEASER_FG, 'important');
    var closeSvg = teaser.querySelector('svg');
    if (closeSvg) closeSvg.style.setProperty('fill', TEASER_FG, 'important');
  }

  function styleFormBody(shadowRoot) {
    var bodyP = shadowRoot.querySelector('[class*="_textBody_"] p');
    if (!bodyP || !/10%\s*off/i.test(bodyP.innerHTML)) return;
    var container = bodyP.parentElement;
    if (container.dataset.zsBodyStyled) return;
    container.dataset.zsBodyStyled = 'true';
    container.innerHTML =
      '<p style="margin:0 0 1em;">Be the first to know our new drops &amp; deals before anyone else.</p>' +
      '<p style="margin:0;">Get an extra <strong style="color:' + TEASER_BG + ';">10% off</strong> coupon when you sign up.</p>';
  }

  function addNoThanksButton(shadowRoot) {
    var submitBtn = shadowRoot.querySelector('[data-testid="btn-form-submit"]');
    if (!submitBtn) return;
    var form = submitBtn.closest('form');
    if (!form || form.querySelector('.zs-no-thanks-btn')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zs-no-thanks-btn';
    btn.textContent = 'No thanks, I want to pay full price';
    btn.style.cssText = [
      'display:block',
      'width:100%',
      'margin:10px 0 0',
      'padding:4px',
      'background:transparent',
      'border:none',
      'color:inherit',
      'opacity:0.65',
      'font-size:12px',
      'text-decoration:underline',
      'cursor:pointer',
      'font-family:inherit'
    ].join(';');

    btn.addEventListener('click', function () {
      var closeBtn = shadowRoot.querySelector('[aria-label="Close modal"]');
      if (closeBtn) closeBtn.click();
    });

    submitBtn.insertAdjacentElement('afterend', btn);
  }

  function sync(shadowRoot) {
    var root = shadowRoot.getElementById('app-embed');
    var step = root && root.getAttribute('data-current-step');
    if (step === 'tease') styleTeaser(shadowRoot);
    if (step === 'form') {
      styleFormBody(shadowRoot);
      addNoThanksButton(shadowRoot);
    }
  }

  function watchEmbed(embed) {
    var shadowRoot = embed.shadowRoot;
    if (!shadowRoot) return;
    sync(shadowRoot);
    var observer = new MutationObserver(function () { sync(shadowRoot); });
    observer.observe(shadowRoot, { childList: true, subtree: true, attributes: true });
  }

  function init() {
    var existing = document.querySelector('shopify-forms-embed');
    if (existing) { watchEmbed(existing); return; }
    var bodyObserver = new MutationObserver(function () {
      var embed = document.querySelector('shopify-forms-embed');
      if (embed) {
        bodyObserver.disconnect();
        watchEmbed(embed);
      }
    });
    bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
